//Lib 
import { mapState } from "vuex";

// Extend
import baseFixedRentalService from '@/scripts/fixedRental/baseFixedRentalService';

// Constant 
import { ROUTE_URL } from '@/constant/route';
import { RENTAL_REQUEST_TYPE } from "@/constant/rental";
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { PERIOD, ELEMENT_LIST_PERIOD, ELEMENT_LIST_PERIOD_ON_CREATED, FIXED_RENTAL_STATUS } from "@/constant/fixedRental";

// Component 

export default {

    extends: baseFixedRentalService,

    computed: {
        ...mapState({
            user: state => state.auth.user,
            tempBalance: state => state.auth.tempBalance,
        }),
    },

    data() {

        return {
            routeUrl: ROUTE_URL,
            //listPeriod: ELEMENT_LIST_PERIOD, 
            fixedRentalStatus: FIXED_RENTAL_STATUS,

            request: {
                campaignName: null,
                period: PERIOD.THREE_HOUR,
                periodUnit: 1,
                totalCost: 0,
                continueRunning: false,
            }
        };
    },

    computed: {
        ELEMENT_LIST_PERIOD_LIST() {
            return process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? ELEMENT_LIST_PERIOD_ON_CREATED : ELEMENT_LIST_PERIOD;
        },
        listPeriod() {
            return process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? ELEMENT_LIST_PERIOD_ON_CREATED : ELEMENT_LIST_PERIOD;
        }
    },

    props: {
        targetImage: {
            type: Object,
            default: null
        },
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.FIXED_RENTAL_CREATE);
        },
        //#endregion

        //#region Fixed rental create
        create() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    campaignName: this.request.campaignName,
                    listMachineId: [this.targetImage.id],
                    // fixedRental: this.targetImage.fixedRental,
                    period: this.request.period,
                    periodUnit: this.request.periodUnit,
                    continueRunning: this.request.continueRunning,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.fixedRentalCreate(
                    data,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion

        //#region Rental request create
        rentalRequestCreate() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: RENTAL_REQUEST_TYPE.NOTIFY_MACHINE_AVAILABLE,
                    packageId: this.targetImage.packageId,
                    operatingSystem: this.targetImage.operatingSystem,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.baseRentalRequestCreate(
                    data,
                    this.targetImage,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion
    },
}